<div class="tag {{ tag.type }}">
  <ui-text>{{ tag.text }}</ui-text>
</div>
